import { http } from "@/lib/http";
export function fetchWheelSummary() {
  return http
    .post("/api/wheel/wheelSummary", "")
    .then((res) => res.data?.data || []);
}
export function wheelExportUrl() {
  return `${import.meta.env.VITE_API_BASE_URL || ""}/api/wheel/exportData`;
}
